// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__7sSQK","getInfo":"Contact_getInfo__7w01a","flexNameEmail":"Contact_flexNameEmail__42QS4","postInfo":"Contact_postInfo__9UP6j"};